const translations = {
    en: {
        shared: {
            nav_bar: {
                welcome: "Welcome!",
                customize: "Customize Your Stay",
                restaurants: "Breakfast & Restaurants",
                reach_us: "How to reach us",
                events: "Event & Attraction",
                news: "Latest news",
                more_languages: "More languages..."
            }
        }
    },
    de: {
        shared: {
            nav_bar: {
                welcome: "Willkommen",
                customize: "Aufenthalt personalisieren",
                restaurants: "Frühstück & Restaurant",
                reach_us: "Lage",
                events: "Ereignisse & Attraktionen ",
                news: "Neueste Nachrichten",
                more_languages: "Andere sprachen..."
            }
        }
    },
    es: {
        shared: {
            nav_bar: {
                welcome: "Bienvenido",
                customize: "Personalize su estancia",
                restaurants: "Desayuno y Restaurantes",
                reach_us: "Como llegar",
                events: "Eventos y atracciones",
                news: "Ultimas noticias",
                more_languages: "Otros idiomas..."
            }
        }
    },
    fr: {
        shared: {
            nav_bar: {
                welcome: "Bienvenue!",
                customize: "Personnalisez votre séjour",
                restaurants: "Manger",
                reach_us: "Comment nous rejoindre",
                events: "Événements & Attractions",
                news: "Dernières nouvelles",
                more_languages: "Autres langues..."
            }
        }
    },
    it: {
        shared: {
            nav_bar: {
                welcome: "Benvenuto!",
                customize: "Personalizza il tuo soggiorno",
                restaurants: "Colazione e Ristoranti",
                reach_us: "Come raggiungerci",
                events: "Eventi ed attrazioni",
                news: "Ultime notizie",
                more_languages: "Altre lingue..."
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/shared/NavBar.js